import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import TaxbillTemplate from '../../components/taxbillmng/TaxbillTemplate';
import {
  unloadTaxbill,
  viewTaxbill,
} from '../../modules/taxbillModule/taxbill';
import TaxBillColAndPayContainer from './TaxBillColAndPayContainer';
import TaxBillDetailContainer from './TaxBillDetailContainer';
import TaxBillIssuedInfoContainer from './TaxBillIssuedInfoContainer';
import TaxBillPerformConfirmContainer from './TaxBillPerformConfirmContainer';

const TaxbillContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  const dispatch = useDispatch();
  const { taxbill, roInfo, user, error, loading } = useSelector(
    ({ taxbillModule, loading }) => ({
      taxbill: taxbillModule.taxbill.taxbill,
      roInfo: taxbillModule.taxbill.roInfo,
      error: taxbillModule.taxbill.error,
      loading: loading['taxbill/VIEW_TAXBILL'],
    }),
  );

  useEffect(() => {
    dispatch(viewTaxbill(id));

    //언마운트될때 리덕스에서 데이터 초기화
    return () => {
      dispatch(unloadTaxbill());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (taxbill) {
      let title = {
        name: taxbill.invNo,
        no: taxbill.invNo,
      };
      setTitleData(title);
    }
  }, [taxbill]);

  const handleGoBack = () => {
    navigate('/taxbillmng');
  };

  const handleEdit = () => {
    navigate(`/taxbillmng/${id}/edit`);
  };

  return (
    <TaxbillTemplate taxbill={taxbill} loading={loading} error={error}>
      <TitleBox
        edit
        handleGoBack={handleGoBack}
        menuName="세금계산서 관리/매출매입 세금계산서/상세보기"
        menuLink="/taxbillmng"
        icon="taxbill"
        titleData={titleData}
        handleEdit={handleEdit}
        editBtnText="세금계산서 발행 요청"
      />
      <DetailTemplate title="기본사항">
        <TaxBillDetailContainer />
      </DetailTemplate>
      <DetailTemplate title="계산서 발행">
        <TaxBillIssuedInfoContainer taxbill={taxbill} />
      </DetailTemplate>
      <DetailTemplate title="수금&amp;지급">
        <TaxBillColAndPayContainer taxbill={taxbill} />
      </DetailTemplate>
      {/* <DetailTemplate title="실적확정">
        <TaxBillPerformConfirmContainer taxbill={taxbill} />
      </DetailTemplate> */}
    </TaxbillTemplate>
  );
};

export default TaxbillContainer;
